/**
 * Create by ZhiXiaPing on 2018/10/24
 *
 */
// -----------保存用户信息的vuex
const state = {
  userInfo: {},
  merchantInfo: {},
  merchantRules: {},
  encrypted_data: {},
  activityConfig: {},
  // 模版类型
  templateType: 0,
  // 是否显示
  showPage: false,
  token_: '',
  isUpdateLocation: false
}
const mutations = {
  saveUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  setShowPage (state, showPage) {
    state.showPage = showPage
  },
  setTemplateType (state, templateType) {
    state.templateType = templateType
    localStorage.setItem('templateType', templateType)
  },
  saveMerchantInfo (state, merchantInfo) {
    state.merchantInfo = merchantInfo
  },
  saveMerchantRules (state, merchantRules) {
    state.merchantRules = merchantRules
  },
  saveToken (state, token) {
    state.token_ = token
    if (token) {
      window.localStorage.setItem('token', token)
    }
  },
  saveEncryptedData (state, token) {
    state.encrypted_data = token
  },
  setUserState (state, encrypted_data) {
    state.userInfo.state = encrypted_data
  },
  setTeachSms (state, teach_sms) {
    state.userInfo.teach_sms = teach_sms
  },
  setLocation (state, isUpdateLocation) {
    state.isUpdateLocation = isUpdateLocation
  }
}
const getters = {
  getShowPage: (state) => {
    return state.showPage
  },
  getUserInfo: (state) => {
    return state.userInfo
  },
  getTemplateType: (state) => {
    return state.templateType || parseInt(localStorage.getItem('templateType')) || 0
    // return state.templateType
  },
  getMerchantInfo: (state) => {
    return state.merchantInfo
  },
  getMerchantRules: (state) => {
    return state.merchantRules
  },
  getToken: (state) => {
    return state.token_
  },
  getEncryptedData: (state) => {
    return state.encrypted_data
  },
  getLocation: (state) => {
    return state.isUpdateLocation
  }
}

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js